/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-06-07 16:47:37
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-09-18 09:32:52
 * @FilePath: /dbrank_b/src/routes/visualChart/P1/index.js
 * @Description: p1
 */
import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './index.css';
import Stage from '../components/Stage';
import setChart from './chart';
import Chart from '../components/Chart';
import { Title4 } from '../components/Titles';
import TooltipDrawer from '../components/TooltipDrawer';
import Form from './Form';
import DBTable from '../components/DBTable';
import FormChart from './FormChart';
import SelectLogo from '../components/SelectLogo';

class P17 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      chartTitle: [],
      chartList: [],
      tableColumns: [],
      tableList: [],
    }
  }
  getMedian = (numbers) =>{
      return Math.ceil(numbers / 2)
  }

  fillColor = (tableColumns) => {
    const border = `none`
    return tableColumns.map((item, index) => {
      return {
        ...item,
        style: {
          ...item.style,
          height: 100,
          lineHeight: '50px',
          fontSize: 24,
          textAlign: 'center',
          verticalAlign: 'top',
          fontWeight: 'bold',
          color: '#000',
          background: '#fff',
          borderRight: border,
          borderBottom: '1px solid #000',
        },
        colStyle: (_, ii, i) => {
          console.log('tableColumns', tableColumns);
          return {
            height: 60,
            fontSize: 16,
            textAlign: 'center',
            fontWeight: index === 0 ? 'bold' : 'normal',
            color: i === this.getMedian(tableColumns.length-1) ? 'red' : '#000',
            background: '#fff',
            borderRight: border,
            borderBottom: ii !== 0 ? '1px solid #000' : border,
          }
        }
      }
    })
  }





  render() {
    const { chartTitle, chartList, tableColumns, tableList, chartColorList } = this.state;
    const width = 1142 / chartList.length;
    return (
      <Stage>
        <Title4 pageNumber="4.1">安踏VS竞品｜全网好感度整体分析</Title4>

        <div className={s.content}>
          <div>
            <div contentEditable className={s.subTitle}>
              阿迪达斯和耐克的好感度仅处于良好区间，安踏和其它品牌处于标杆区间
            </div>
            <div contentEditable className={s.des}>
              监测期内，安踏的好感度为92.75%，处于标杆区间，但排名第四，主要是女鞋海报风波对其造成较大的负面影响。
            </div>
            <div contentEditable className={s.des}>
              竞品中，361度、特步、斐乐的负面内容较少，好感度均在95%以上。李宁主要是新品酷似日军军服和高管回应态度引发大量网友不满。阿迪达斯和耐克的负面内容相对较多，主要是耐克退出俄罗斯市场和在华发展受困、阿迪达斯万元雨伞不防水被嘲和其CEO承认在中国犯了错误等。
            </div>
          </div>

          <div className={s.uiWrapper}>
            <div className={s.chartWrapper}>
              {chartList.map((item, index) => (
                <div
                  key={index}
                  className={s.logoWrapper}
                  style={{
                    left: width * index + width / 2,
                  }}>
                  <SelectLogo iconId={item.id} className={s.selectLogoClassName} imgClassName={s.imgBox} />
                </div>
              ))}

              <TooltipDrawer
                style={{ width: '100%', height: '100%' }}
                formContent={<FormChart onChange={values => this.setState({ ...values })} />}>
                <Chart options={setChart({
                  label: chartTitle,
                  list: chartList,
                  color: chartColorList
                })} />
              </TooltipDrawer>
            </div>

            <div className={s.tableWrapper}>
              <TooltipDrawer formContent={<Form onChange={values => this.setState({ ...values })} />}>
                <DBTable columns={this.fillColor(tableColumns)} data={tableList} style={{ boxShadow: 'none' }} />
              </TooltipDrawer>
            </div>
          </div>

        </div>
      </Stage>
    );
  }
}

export default withStyles(s)(P17);



// WEBPACK FOOTER //
// src/routes/visualChart/P17/index.js